import React from 'react' // , { useEffect }
// import { useDispatch } from 'react-redux'
// import { setErrorStatus } from 'src/store/slices/authSlice'
import MobileErrorStatus from 'src/mobile/components/ErrorStatus'

const NoFound = () => {
  // const dispatch = useDispatch()
  // useEffect(() => {
  //   dispatch(setErrorStatus(404))
  // }, [])
  return <MobileErrorStatus isNotFound={true} />
}

export default NoFound
